
import React, { BaseSyntheticEvent, Fragment, useEffect, useRef, useState } from 'react';
import { CQAppConstant } from '../../../../../app-constants';
import { observer } from 'mobx-react';
import LayoutFieldsConfigController from '../../../layout-level-fields.controller';
import { ICriteria, IExtendedTransferRule, IOnLoadTransferRulesModalProps, ITransferRule } from '../../ILayoutConfigurationPanel.Interface';
import '../apply-rule-modal.css';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { Utility } from '../../../../../common/utility';
import { CQAppStore } from '../../../../../store/cq-app-store';
import { CommonRuleModal } from '../common-rule-modal';

const INITIAL_STATE = {
    field: '',
    operator: '',
    compareTo: '',
    isDynamic: false,
    selectedFieldType: '',
    referenceField: '',
    referenceTo: '',
    relationshipName: ''
}
const layoutFieldsConfigCtrl = new LayoutFieldsConfigController();
const utility = new Utility();

const OnLoadTransferRulesModalComponent = (props: IOnLoadTransferRulesModalProps ) => {
    const layoutFields = layoutFieldsConfigCtrl.getLayoutFields(props.selectedTemplateName);
    const lookupFieldsFromlayout = layoutFields.filter((fieldData) => fieldData.fieldType === CQAppConstant.LOOKUP_TEXT || fieldData.fieldType === CQAppConstant.MASTERDETAIL_TEXT);
    const [state, setState] = useState(() => ({
        setValues: [{
            addedCriterias: [INITIAL_STATE],
            actionArray: [
                {
                    selectedLookupValue: '',
                    selectedLayoutField: '',
                }
            ],
            complexLogicQuery: '1',
            complexLogicVisibility: false,
            shouldSkip: false
        }]

    }))

    const [extraState, setExtraState] = useState<IExtendedTransferRule >(() => ({
        additionalFields: [],
        fieldWisePicklistValues: [],
        selectedReferenceFields: [],
        selectedLookupFieldAPIName: '',
        selectedfieldFullName: '',
        lookupFieldsArray: [],
        layoutFieldsArray: [],
    }));

    const [shouldValidate, setShouldValidate] = useState(false);

    useEffect(() => {
        async  function intitializeState(){
            CQAppStore.loader.setVisibility(true);
            setLayoutFields();
            if (props.appliedRule) {
                const ruleObject = CQMasterDataStore.RuleElements.FieldRuleElement;
                
                const objectName: any = props.objectName;
                
                const ruleElement = { ...(ruleObject[objectName])[props.appliedRule] };
                
                await getLookupObjectFields(ruleElement.selectedLookupFieldAPIName , ruleElement.selectedfieldFullName);

                const selectedObjectName = CQMasterDataStore.OutputConfig.getStoreKeyData(props.selectedTemplateName,'selectedObject');
                const extraStateCopy = utility.createObjectDeepCopy(extraState);

                if(!ruleElement.setValues){
                    const stateCopy = utility.createObjectDeepCopy(state);
                    stateCopy.setValues[0].actionArray = [];
                    Object.keys(ruleElement.actionArray).forEach((rule) => {
                        stateCopy.setValues[0].actionArray.push(ruleElement.actionArray[rule])
                    });
                    extraStateCopy.selectedLookupFieldAPIName  = ruleElement.selectedLookupFieldAPIName;
                    extraStateCopy.selectedfieldFullName = ruleElement.selectedfieldFullName
                    setState(stateCopy);
                    setExtraState(extraStateCopy);
                }else{
                    if (ruleElement.length !== 0) {
                        let selectedReferenceFields: any[] | undefined = [];
                        let fieldWisePicklistValues = ruleElement.fieldWisePicklistValues;
                        if (ruleElement.selectedReferenceFields) {
                            selectedReferenceFields = await layoutFieldsConfigCtrl.getLookFieldsDataInEditMode(ruleElement.selectedReferenceFields);
                            selectedReferenceFields = (selectedReferenceFields && selectedReferenceFields.length > 0) ? selectedReferenceFields : [];
                        }
                        if (fieldWisePicklistValues) {
                            fieldWisePicklistValues = await layoutFieldsConfigCtrl.getPickListValueDataInEditMode(selectedObjectName, ruleElement.fieldWisePicklistValues);
                            fieldWisePicklistValues = (fieldWisePicklistValues && fieldWisePicklistValues.length > 0) ? fieldWisePicklistValues : [];
                        }
                        setState({
                            setValues: ruleElement.setValues,   
                        });
                        extraStateCopy.additionalFields = ruleElement.additionalFields;
                        extraStateCopy.selectedLookupFieldAPIName  = ruleElement.selectedLookupFieldAPIName;
                        extraStateCopy.selectedfieldFullName = ruleElement.selectedfieldFullName;
                        extraStateCopy.lookupFieldsArray  = ruleElement.lookupFieldsArray;
                        extraStateCopy.layoutFieldsArray = ruleElement.layoutFieldsArray;
                        setExtraState(extraStateCopy);
                    }
                }
            }
            CQAppStore.loader.setVisibility(false);
        }
        intitializeState();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        updateRuleObject(CQAppConstant.ADDED_CRITERIAS, generateMergedStore());
        props.checkValidation(validateAddRuleForm());

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    useEffect(() => {
        updateRuleObject(CQAppConstant.ADDED_CRITERIAS, generateMergedStore());

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [extraState]);

    /**
     * @description Used to Merge store 
     * @memberof OnLoadTransferRulesModalComponent
     */
    function generateMergedStore() {
        return { ...state, ...extraState };
    }

    /**
     * @description Updates the layout field
     * @memberof OnLoadTransferRulesModalComponent
     */
    function setLayoutFields () {
        const layoutFields = layoutFieldsConfigCtrl.getLayoutFields(props.selectedTemplateName);
        const extraStateCopy = utility.createObjectDeepCopy(extraState);
        extraStateCopy.layoutFieldsArray= layoutFields;
        setExtraState(extraStateCopy);
    }
      
    /**
     * @description updates rule object and checks for validation for rule
     * @memberof OnLoadTransferRulesModalComponent
     */
    function updateRuleObject(ruleObjectProperty: string, ruleObjectValue: any) {
        props.setRuleObject(ruleObjectValue);
        props.checkValidation(validateAddRuleForm());
    }

    /**
     * @description Used for validation for rule added for field type
     * @memberof OnLoadTransferRulesModalComponent
     */
    function validateAddRuleForm() {
        if(!shouldValidate){
            return true;
        } 
        let isComplexLogicValid = false;
        let isActionArrayValid = false;
        let isCriteriaValid = false;
        state.setValues.forEach((setValueSection) => {
            isCriteriaValid = setValueSection.addedCriterias.every((criteria: ICriteria, index: number) => (
                criteria.field !== ''
                && criteria.operator !== ''
                && ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY) ? true : (criteria.compareTo !== ''))
                && ((CQAppConstant.REFERENCE_FIELD_TYPE).includes( criteria.selectedFieldType) ?
                    ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY || index === 0) ? true :
                        (criteria.referenceField !== '')) : true)));

            if(setValueSection.shouldSkip){
                isCriteriaValid = true;
            }

            isActionArrayValid = setValueSection.actionArray.every((action: any) => (
                action.selectedLayoutField !== ''
                && action.selectedLookupValue !== ''));
            isComplexLogicValid = (setValueSection.complexLogicQuery === '');
            return (isCriteriaValid && isComplexLogicValid);
        });
        if (!isCriteriaValid || !isActionArrayValid || isComplexLogicValid) {
            return true;
        }
        return false;
    }

    /**
     * @descritption Updates the lookup field for field name in the store
     * @param selectedLookupFieldAPIName
     * @param selectedfieldFullName
     * @memberof OnLoadTransferRulesModalComponent
     */
    async function getLookupObjectFields (selectedLookupFieldAPIName: string, selectedfieldFullName: string ){
        try {
            const lookupObjectFields = await layoutFieldsConfigCtrl.getLookupFields(selectedLookupFieldAPIName);

            CQAppStore.loader.setVisibility(false);
            
            if (lookupObjectFields.fields) {
                const extraStateCopy = utility.createObjectDeepCopy(extraState);
                extraStateCopy.selectedLookupFieldAPIName = selectedLookupFieldAPIName
                extraStateCopy.selectedfieldFullName = selectedfieldFullName

                extraStateCopy.lookupFieldsArray = lookupObjectFields.fields
                setExtraState(extraStateCopy);
            }
        } catch (error : any) {
            props.toggleModalVisibility();
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: error.error ? error.error : error.message,
                errorStatus: error.status,
                componentName: ''
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    /**
     * @description Updates  fields for set value rule
     * @memberof OnLoadTransferRulesModalComponent
     */
    function setValueRule(setValueSectionIndex: number) {
        let setValues = state.setValues;
        const extraStateCopy = utility.createObjectDeepCopy(extraState);
        const updatedAdditionalFields = removeAllAdditionalFields(setValueSectionIndex);

        setValues = setValues.filter((setValueSection, index: number) => index !== setValueSectionIndex);
        extraStateCopy.selectedReferenceFields = []
        extraStateCopy.fieldWisePicklistValues = []
        extraStateCopy.additionalFields = updatedAdditionalFields

        setExtraState(extraStateCopy);
        setState({ setValues })
    }

    /**
     * @description Used to set value on Action field
     * @param e event to set value for action field
     * @memberof OnLoadTransferRulesModalComponent
     */
    function onActionFieldChanged(e: BaseSyntheticEvent,iterationIndex: number, setValueSectionIndex: number) {
        setValidation();
        const stateCopy = utility.createObjectDeepCopy(state);
        const selectedLookupValue = e.target.value;
        stateCopy.setValues[setValueSectionIndex].actionArray[iterationIndex].selectedLookupValue = selectedLookupValue;
        stateCopy.setValues[setValueSectionIndex].actionArray[iterationIndex].selectedLayoutField = '';
        setState(stateCopy)
    }

    /**
     * @description Removes additional field
     * @memberof OnLoadTransferRulesModalComponent
     */
    function removeAllAdditionalFields(setValueSectionIndex: number) {
        const setValues = state.setValues;
        let additionalFields = [...extraState.additionalFields];
        const fields = setValues[setValueSectionIndex].addedCriterias.map((criteria: ICriteria) => criteria.field);
        fields.forEach((fieldName: string) => {
            additionalFields = additionalFields.filter((additionalField: string) => additionalField !== fieldName);
        });
        return additionalFields;
    }

    /**
     * @description add action field 
     * @memberof OnLoadTransferRulesModalComponent
     */
    function addCriteria (setValueSectionIndex: number){
        setValidation();
        const stateCopy = utility.createObjectDeepCopy(state);
        const actionSet = {
            selectedLookupValue: '',
            selectedLayoutField: '',
        };
        stateCopy.setValues[setValueSectionIndex].actionArray.push(actionSet);
        setState(stateCopy);
    }

    /**
     * @description deletes the action added
     * @memberof OnLoadTransferRulesModalComponent
     */
    function deleteCriteria (setValueSectionIndex: number, interationIndex: number) {
        setValidation();
        const setValues = state.setValues;
        setValues[setValueSectionIndex].actionArray.splice(interationIndex, 1);
        setState({setValues});
    }

    /**
     * @description adds set values in array 
     * @memberof OnLoadTransferRulesModalComponent
     */
    function addSetValueSection(setValueSectionIndex: number) {
        setValidation();      
        const stateCopy = utility.createObjectDeepCopy(state);
        const setValueSection ={
            addedCriterias: [INITIAL_STATE],
            actionArray: [
                {
                    selectedLookupValue: '',
                    selectedLayoutField: '',
                }
            ],
            complexLogicQuery: '1',
            complexLogicVisibility: false,
            shouldSkip: false
        }
        stateCopy.setValues.push(setValueSection);
        setState(stateCopy)
    }

    /**
     * @description  renders dynamic field for action
     * @memberof OnLoadTransferRulesModalComponent
     */
    function onOperatorChanged  (e: BaseSyntheticEvent, iterationIndex: number, setValueSectionIndex: number) {
        setValidation();
        const selecetdLayoutField = e.target.value;
        const setValues = state.setValues;
        const actionArray = setValues[setValueSectionIndex].actionArray;
        const actionSet = { ...actionArray[iterationIndex] };
        
        actionSet.selectedLayoutField = selecetdLayoutField;
        setValues[setValueSectionIndex].actionArray[iterationIndex] = actionSet;
        setState({setValues});
    }

    /**
     * @descripton Sets value for lookupfield
     * @param e event to set value for lookup field
     * @memberof OnLoadTransferRulesModalComponent
     */
    function onLookupFieldChanged (e: BaseSyntheticEvent) {
        setValidation();
        let fieldAPIName = e.target.value;
        let fieldFullName = '';

        const extraStateCopy = utility.createObjectDeepCopy(extraState);

        Object.keys(lookupFieldsFromlayout).forEach(function (layout: any){
            if(lookupFieldsFromlayout[layout].referenceTo === fieldAPIName){
                fieldFullName = lookupFieldsFromlayout[layout].fieldFullName;
            }
        });
        if (fieldAPIName !== '') {
            extraStateCopy.selectedLookupFieldAPIName = fieldAPIName;
            extraStateCopy.selectedfieldFullName = fieldFullName;

            setExtraState(extraStateCopy)            
            getLookupObjectFields(fieldAPIName,fieldFullName);
        }
    }

    /**
     * @description Used to set validation true for new states
     * @param newState contains state copy
     */
    function updateState (newState: ITransferRule) {
        setValidation();
        setState(newState);
    }
    
    /**
     * @description Used to validate rule
     */
    function setValidation() {
        if (!shouldValidate) {
            setShouldValidate(true);
        } 
    }
    
    return (
        <>
         <React.Fragment>
                <div className="slds-grid">
                    <div className="slds-size_10-of-12">
                        <div className="slds-form-element slds-form-element_horizontal">
                            <label className="slds-form-element__label" >Select Lookup Field</label>
                            <div className="slds-form-element__control">
                                <div className="slds-select_container">
                                    <select className="slds-select"
                                        onChange={onLookupFieldChanged}
                                        value={extraState.selectedLookupFieldAPIName}
                                    >
                                        <option value="">Please select</option>
                                        {
                                            lookupFieldsFromlayout.map((lookupField) => {
                                                return (<option key={lookupField.fieldFullName}
                                                    value={lookupField.referenceTo}>{lookupField.fieldLabel} - {lookupField.fieldFullName}</option>);
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { extraState.selectedLookupFieldAPIName !== '' &&
                    <div className="slds-grid slds-grid_vertical">
                    {
                        state.setValues && state.setValues.map((setValueSection, setValueSectionIndex: number) => {
                            return (
                                <React.Fragment key={setValueSectionIndex}>
                                    <div className="slds-grid slds-grid_align-spread slds-grid_vertical-align-center slds-m-bottom_small">
                                        <h2>{`Rule ${setValueSectionIndex + 1}`} </h2>
                                        {setValueSectionIndex !== 0 &&
                                            <button className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => {
                                                setValueRule(setValueSectionIndex);
                                            }}>
                                                <i className="cq-icon-delete"></i>
                                            </button>

                                        }
                                    </div>

                                {
                                    <CommonRuleModal
                                        modalInfo={{
                                            shouldRenderAddComplexBtn: true,
                                            shouldDisableFirstElement: false,
                                            toggleModalVisibility: props.toggleModalVisibility
                                        }}
                                        parentAction={{
                                            updateState: (state: ITransferRule) => updateState(state),
                                            updateExtraState: (state: IExtendedTransferRule) => setExtraState(state)
                                        }}
                                        parentInfo={{
                                            state: state.setValues,
                                            extraState,
                                            initialCriteria: INITIAL_STATE,
                                            sectionIndex: setValueSectionIndex,
                                            addFieldOnSkip: false,
                                        }}
                                        objectName={props.objectName}
                                        templateName={props.selectedTemplateName}
                                        selectedRule='setValues'
                                    />
                                }
                                <div key={`setobject`} className="slds-grid slds-grid_vertical formulaFieldFieldOperatorGrid">
                                    <h3 className="slds-m-bottom_small">Set Actions</h3>
                                    {
                                        setValueSection.actionArray.map((actionSet: any, iterationIndex: number) => {
                                            
                                            return (
                                                <React.Fragment key={`Action ${iterationIndex}`}>
                                                    <div className="slds-grid slds-grid_vertical-align-center slds-gutters_x-small full-width rules-set">
                                                        <div className="slds-col col-sm slds-m-bottom_small">{iterationIndex + 1}</div>
                                                        <div className="slds-col slds-size_5-of-12">
                                                            <div className="slds-form-element">
                                                                <div className="slds-form-element__control">
                                                                    <div className="slds-select_container">
                                                                        <select className="slds-select" id="select-01"
                                                                            onChange={e => onActionFieldChanged(e, iterationIndex, setValueSectionIndex)}
                                                                            value={actionSet.selectedLookupValue}>
                                                                            <option value="">Select Source Field</option>
                                                                            {
                                                                                extraState.lookupFieldsArray && extraState.lookupFieldsArray.length > 0 && extraState.lookupFieldsArray
                                                                                    .map((field, index: number) => {
                                                                                        return (<option key={index} value={field.name}>{field.label} - {field.name}</option>);
                                                                                    })
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="slds-col slds-size_5-of-12">
                                                            <div className="slds-form-element">
                                                                <div className="slds-form-element__control">
                                                                    <div className="slds-select_container">
                                                                        <select className="slds-select" onChange={e => onOperatorChanged(e, iterationIndex, setValueSectionIndex)}
                                                                            disabled={!actionSet.selectedLookupValue} value={actionSet.selectedLayoutField}>
                                                                            <option value="">Select Target Field</option>
                                                                            {
                                                                                extraState.layoutFieldsArray &&
                                                                                extraState.layoutFieldsArray.map((field, index: number) => {
                                                                                    return (<option key={index} value={field.fieldFullName}>
                                                                                        {`${field.fieldLabel} - ${field.fieldFullName}`}</option>);
                                                                                })
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="slds-col slds-size_2-of-12">
                                                            <div className="slds-grid slds-m-bottom_xx-small">
                                                                <button className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-horizontal_small" onClick={() => {
                                                                    addCriteria(setValueSectionIndex);
                                                                }}>
                                                                    <i className="cq-icon-add"></i>
                                                                </button>
                                                                {
                                                                    iterationIndex > 0 && <button className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => {
                                                                        deleteCriteria(setValueSectionIndex, iterationIndex);
                                                                    }}>
                                                                        <i className="cq-icon-delete"></i>
                                                                    </button>
                                                                }

                                                            </div>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })
                                    }
                                </div>
                                <div className="slds-border_bottom slds-m-vertical_small"></div>
                                { state.setValues.length - 1 === setValueSectionIndex &&
                                    <div className="slds-grid_absolute-center">
                                        <button role="addition-rule" className="slds-button slds-button_neutral slds-m-top_x-small"
                                            onClick={() => addSetValueSection(setValueSectionIndex)}
                                        >Add Additional Rule</button>
                                    </div>
                                }
                            </React.Fragment>)
                         })
                    }
                </div>
            }
            </React.Fragment>
        </>
    );
}
export const OnLoadTransferRulesModal = observer(OnLoadTransferRulesModalComponent);
